import { AppMaterialModule } from "src/app/layouts/material/app.material.module";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { AiOrbComponent } from './components/ai-orb/ai-orb.component';
import { CustomInputNumberComponent } from './components/custom-input-number/custom-input-number.component';
import { DebounceClickDirective } from "./directives/debounce-click.directive";
import { DeclarationConfirmationComponent } from './components/declaration-confirmation/declaration-confirmation.component';
import { DialogComponent } from "./components/dialog/dialog.component";
import { DragAndDropComponent } from './components/drag-and-drop/drag-and-drop.component';
import { DragAndDropFilesDirective } from "./directives/drag-and-drop-files.directive";
import { EqualValidatorDirective } from './directives/equal-validator.directive';
import { FooterComponent } from "./components/footer/footer.component";
import { InnerLinksDirective } from './directives/inner-links.directive';
import { IntegerSpinnerComponent } from "./components/integer-spinner/integer-spinner.component";
import { LoadingComponent } from "./components/loading/loading.component";
import { PieceCheckboxDirective } from './directives/piece-checkbox.directive';
import { PiecesContainerComponent } from './components/pieces-container/pieces-container.component';
import { ProductThumbComponent } from './components/product-thumb/product-thumb.component';
import { DialogComponent2 } from "./components/dialog2/dialog2.component";
import { DialogAliwellComponent } from "./components/dialog-aliwell/dialog-aliwell.component";
import { MatLikeStepperComponent } from "./components/mat-like-stepper/mat-like-stepper.component";
import { StlViewerComponent } from "./components/stl-viewer/stl-viewer.component";
import { ToothDiagramComponent } from "./components/tooth-diagram/tooth-diagram.component";
import { ImageCropperModule } from "ngx-image-cropper";
import { PatientAvatarComponent } from "./components/patient-avatar/patient-avatar.component";
import { PatientContactFieldsComponent } from "./components/patient-contact-fields/patient-contact-fields.component";
import { PatientPersonalFieldsComponent } from "./components/patient-personal-fields/patient-personal-fields.component";
import { PatientEditDialogComponent } from "./components/patient-edit-dialog/patient-edit-dialog.component";
import { PatientPhotoPickerComponent } from "./components/patient-photo-picker/patient-photo-picker.component";
import { PatientGenderPipe } from "./pipes/patient-gender.pipe";
import { PatientService } from "./services/patient.service";

@NgModule({
  declarations: [
    AiOrbComponent,
    CustomInputNumberComponent,
    DebounceClickDirective,
    DialogComponent,
    DialogComponent2,
    DialogAliwellComponent,
    MatLikeStepperComponent,
    DragAndDropComponent,
    DragAndDropFilesDirective,
    EqualValidatorDirective,
    FooterComponent,
    InnerLinksDirective,
    IntegerSpinnerComponent,
    LoadingComponent,
    PieceCheckboxDirective,
    PiecesContainerComponent,
    ProductThumbComponent,
    StlViewerComponent,
    ToothDiagramComponent,
    DeclarationConfirmationComponent,
    PatientAvatarComponent,
    PatientContactFieldsComponent,
    PatientPersonalFieldsComponent,
    PatientGenderPipe,
    PatientEditDialogComponent,
    PatientPhotoPickerComponent,
  ],
  imports: [
    AppMaterialModule,
    CommonModule,
    FormsModule,
    ImageCropperModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  exports: [
    AiOrbComponent,
    CustomInputNumberComponent,
    DebounceClickDirective,
    DialogComponent,
    DialogAliwellComponent,
    DialogComponent2,
    MatLikeStepperComponent,
    DragAndDropComponent,
    DragAndDropFilesDirective,
    EqualValidatorDirective,
    FooterComponent,
    InnerLinksDirective,
    IntegerSpinnerComponent,
    LoadingComponent,
    PieceCheckboxDirective,
    PiecesContainerComponent,
    ProductThumbComponent,
    StlViewerComponent,
    ToothDiagramComponent,
    DeclarationConfirmationComponent,
    PatientAvatarComponent,
    PatientContactFieldsComponent,
    PatientPersonalFieldsComponent,
    PatientGenderPipe,
    PatientEditDialogComponent,
    PatientPhotoPickerComponent,
  ],
  providers: [
    PatientService,
  ]
})
export class AppShareModule { }
